import React, { Component } from 'react';
import { NavLink } from "react-router-dom";


// Third Party
import { FaLinkedin } from 'react-icons/fa';

class AppItem extends Component {
  render() {
    return (
      <NavLink 
        to={this.props.navLink}
        target={this.props.external ? "_blank" : "" }
        className={"tile " + this.props.addClass}
        onClick={this.props.onClick}
        src={this.props.src}
        alt={this.props.apptitle} 
        style={{
          textDecoration: 'none',
          backgroundColor: this.props.backgroundColor,
        }}
      >
        {!this.props.textTile && 
          <img 
            alt=""
            src={this.props.imgSrc}
            style={{
              width: '100px'
            }}
          />
        }

        { this.props.textTile && 
        <div>
          <img
            alt=""
            src={this.props.profilePic}
            style={{
              height: "75px",
              width: "75px",
              borderRadius: '75px',
              display: 'flex',
              alignSelf: 'flex-start',
              objectFit: 'cover',
              marginBottom: '16px'

            }}
          />
          <p class="intro-text">{this.props.textTile}</p>
          <p class="intro-copy">{this.props.textCopy}</p>

          { this.props.socialCTA &&
            <div className="social-cta">
              <FaLinkedin/> <p class="social-cta-text">Connect on LinkedIn</p>
            </div>
          }
        </div>
        }

   
      </NavLink>
    );
  }
}

export default AppItem;



// WEBPACK FOOTER //
// ./src/components/AppItem.js